import { environment } from 'src/environments/environment';
import { RailgunError } from './RailgunError';
import { LoggerUtil } from './Util/LoggerUtil';

/**
 * RailgunBase
 * 基本となるベースクラス
 */
export class RailgunBase {
	// エラー伝搬用エラーオブジェクト
	private errorObj: RailgunError;

	/**
	 * エラー情報のコピー。DAOからサービスに渡す時とかに使う。
	 * @param obj コピー元のオブジェクト
	 */
	public errorCopy(obj: RailgunBase) {
		this.errorObj = obj.getErrorObj();
	}

	/**
	 * getErrorObj
	 * エラーオブジェクトの取得
	 */
	public getErrorObj(): RailgunError {
		return this.errorObj;
	}

	/**
	 * setErrorObj
	 * エラーオブジェクトの設定
	 */
	public setErrorObj(obj: RailgunError) {
		this.errorObj = obj;
	}

	/**
	 * log
	 *
	 * コンソールでログ出力を行う
	 * @param msg メッセージ
	 */
	public log(msg: any) {
		// Productionビルドの時はださない
		if (!environment.production) {
			LoggerUtil(msg);
		}
	}

	/**
	 * obj2Array
	 * toCamelでobjectになったらやつを戻す。
	 * HACK: やっつけコードなので、後で調整。
	 * @param obj 戻すやつ
	 */
	public obj2Array(obj: any): Array<any> {
		if (!obj) {
			return null;
		}
		return Object.keys(obj).map(key => obj[key]);
	}
}
